module.exports = "/_next/static/files/837204af9f149d84dae9cabd8c2f3f26.svg";